<template>
    <div class="results-map">
        <div ref="map" class="results-map__map"></div>

        <template v-if="api && map">
            <slot :api="api" :map="map"></slot>
        </template>
    </div>
</template>

<script>
    import GoogleMapsApiLoader from 'google-maps-api-loader'

    export default {
        props: {
            centerAt: { type: String, required: true },
        },

        data() {
            return {
                api: null,
                map: null,
            }
        },

        methods: {
            initializeMap() {
                this.map = new this.api.maps.Map(this.$refs.map, {
                    clickableIcons: false,
                    streetViewControl: false,
                    panControlOptions: false,
                    gestureHandling: 'cooperative',
                    mapTypeControl: false,
                    zoomControlOptions: { style: 'SMALL' },
                    zoom: 14,
                    minZoom: 2,
                })
            },

            findCenterPoint() {
                new this.api.maps.Geocoder().geocode({ address: this.centerAt }, (results, status) => {
                    if (status !== this.api.maps.GeocoderStatus.OK) {
                        return
                    }

                    this.map.setCenter(results[0].geometry.location)
                })
            },
        },

        mounted() {
            GoogleMapsApiLoader({ apiKey: env('VUE_APP_GM_API_KEY') }).then((api) => {
                this.api = api

                this.initializeMap()
                this.findCenterPoint()
            })
        },
    }
</script>
